import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export interface DeviceStatusState {
  newDeviceIds: string[];
}

const initialState: DeviceStatusState = {
  newDeviceIds: [],
};

const deviceStatusSlice = createSlice({
  name: 'deviceStatus',
  initialState,
  reducers: {
    flagNewDevice(state, action: PayloadAction<string>) {
      if (!state.newDeviceIds.includes(action.payload)) {
        state.newDeviceIds.push(action.payload);
      }
    },
    acknowledgeNewDevice(state, action: PayloadAction<string>) {
      state.newDeviceIds = state.newDeviceIds.filter(id => id !== action.payload);
    },
  },
});

export const selectNewDeviceIds = (state: RootState) =>
  state.deviceStatus.newDeviceIds;
export const { flagNewDevice, acknowledgeNewDevice } = deviceStatusSlice.actions;
export default deviceStatusSlice.reducer;
